import './App.scss'
import { ReportView } from './report-view'

export const App = () => {
  return <ReportView />
}
